// Modules
import React, { useState } from 'react';
import i18n from 'i18n-react';
import { connect } from 'react-redux';

// Components
import Button from '../core/button/ButtonView';
import AlertPopupsView from '../core/alertPopups/AlertPopupsView';
import InputField from '../core/inputfield/InputFieldView';

// Styling
import './login.scss';
import withRouter from '../../hoc/withRouter';

const Login = (props) => {
    const { loginPending, login } = props;
    const [password, setPassword] = useState('');
    const [username, setUserName] = useState('');

    const handleChangeUsername = (e) => {
        setUserName(e.target.value);
    };

    const handleChangePassword = (e) => {
        setPassword(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        login({
            hostname: window.location.host,
            username: username,
            password: password,
        });
    };

    return (
        <div id="page-login">
            <div className="login-box">
                <div className="login-message">{i18n.translate('account.loginPage.welcomeTo')}</div>
                <AlertPopupsView />
                <form>
                    <fieldset disabled={!!loginPending}>
                        <InputField
                            type="email"
                            name="username"
                            placeholder={i18n.translate('account.username')}
                            inputGroupAlreadyExist={true}
                            required="required"
                            onChange={handleChangeUsername}
                        />
                        <InputField
                            type="password"
                            name="password"
                            placeholder={i18n.translate('account.password')}
                            inputGroupAlreadyExist={true}
                            required="required"
                            onChange={handleChangePassword}
                        />
                        <Button
                            className="btn-doorklik"
                            text={i18n.translate('account.login')}
                            type="submit"
                            onClick={handleSubmit}
                        />
                    </fieldset>
                </form>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    loginPending: state.uiState.authenticationState.loginPending,
    loginFailed: state.uiState.authenticationState.loginFailed,
    loggedIn: state.uiState.authenticationState.loggedIn,
    logoutPending: state.uiState.authenticationState.logoutPending,
});

const mapDispatchToProps = {
    login: ({ hostname, username, password }) => ({
        type: 'LOGIN',
        data: {
            hostname,
            username,
            password,
        },
    }),
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
